import { Airport } from "shared/types/airportsTypes";

export const topNationalDestinationsData: Airport[] = [
  {
    description: "São Paulo - Todos os aeroportos (SAO), Brasil",
    name: "São Paulo",
    code: "SAO",
  },
  {
    description: "Recife - Guararapes Intl (REC), Brasil",
    name: "Recife",
    code: "REC",
  },
  {
    description: "São Paulo - Guarulhos Intl (GRU), Brasil",
    name: "São Paulo",
    code: "GRU",
  },
  {
    description: "Fortaleza - Pinto Martins (FOR), Brasil",
    name: "Fortaleza",
    code: "FOR",
  },
  {
    description: "Salvador - Dep. Luís Eduardo Magalhães (SSA), Brasil",
    name: "Salvador",
    code: "SSA",
  },
];
